export default {
  Helptext1: "Mehrere Suchbegriffe können durch Leerzeichen getrennt werden.",
  Helptext2: "Mit Anführungszeichen '...' kann nach einer exakten Zeichenfolge gesucht werden.",
  Helptext3: "Es ist auch möglich nach mehreren exakten Zeichenfolgen '...' '...' '...' zu suchen.",
};
